import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const lossOfConsciousnessBalanceDizziness: AnswerPathTreeNode = {
  path: 'lossOfConsciousnessBalanceDizziness',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredLossOfConsciousnessBalanceDizzinessDetails }],
};
